import CheckOutContainer from "../../../components/applications/eCommerce/checkOut";

const Checkout = () => {
  return <CheckOutContainer />;
};

export default Checkout;
